import { Navigate, useLocation } from "react-router-dom";

// Short affiliate aliases (/lifetime, /youtube-clipping …) → canonical landing page, keeping ?via= and UTM params intact.
export function RedirectKeepQuery({ to }) {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
}
